import { useState } from "react";
import { addFeaturesForm, addPagesSectionForm } from "../../lib/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DropDownFilterPaginations from "../../components/GDropDownList/DropDownFilterPaginations";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Editor } from '@tinymce/tinymce-react';

export default function AddPagesSectionUi() {

  const nav = useNavigate();
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const t = i18n.t.bind(i18n); 
  const currentLang = i18n.language;
  const [isActive, setIsActive] = useState(true); // ✅ new state for toggle

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    formData.append("active", isActive ? 1 : 0); // ✅ include toggle value
    
    const result = await addFeaturesForm(formData, navigate);
    setLoading(false);
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImage(URL.createObjectURL(file));
    }
  };

  const handleDeleteImage = () => {
    setImage(null);
  };

  const navigate = (route) => {
    nav(route);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
        <div className="mb-4">
          <label className="block text-white mb-2"> {currentLang === "en" ? "title in arabic" : "الاسم بالعربي "} </label>
          <input
            type="text"
            name="name[ar]"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter name in arabic " : "ادخل العنوان باللغة العربية"}
          />
        </div>
        <div className="mb-4">
          <label className="block text-white mb-2"> {currentLang === "en" ? "title in english" : "الاسم بالانجليزي "} </label>
          <input
            type="text"
            name="name[en]"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter name in english " : "أدخل العنوان باللغة الانجليزية"}
          />
        </div>

        {/* Arabic Description Editor */}
        <div className="mb-4 md:col-span-2">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "description in arabic" : "الوصف بالعربية"}
          </label>
                    <input
                        type="text"
                        name="description[ar]"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in arabic " : "ادخل الوصف باللغة العربية"}
                    />
        </div>

        {/* English Description Editor */}
        <div className="my-1 md:col-span-2">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "description in english" : "الوصف بالإنجليزية"}
          </label>
                    <input
                        type="text"
                        name="description[en]"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in english " : "ادخل الوصف باللغة الانجليزية"}
                    />
        </div>

                <div className="mb-6 ">
                    <label className="block text-white mb-4">
                        {currentLang === "en" ? "Active Status" : "حالة التفعيل"}
                    </label>
                    <div className="flex items-center gap-3">
                        <div
                            onClick={() => setIsActive(!isActive)}
                            className={`relative w-14 h-7 rounded-full cursor-pointer transition
                            ${isActive ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
                        >
                            <span
                            className={`w-5 h-5 mt-1 bg-white rounded-full shadow-md block
                                transform transition
                                ${isActive ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                            />
                        </div>
                        <span className="text-white text-sm">
                        {isActive
                            ? currentLang === "en"
                            ? "Active"
                            : "مفعل"
                            : currentLang === "en"
                            ? "Inactive"
                            : "غير مفعل"}
                        </span>
                    </div>
                </div>

      </div>

      {/* Image uploader block remains unchanged */}
      <div className="mb-4">
        <label className="block text-white mb-6">{currentLang === "en" ? "photo" : "الصورة"}</label>
        <div className="flex justify-center items-center">
          <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
            <div className="relative group">
              <div className={`flex flex-col items-center justify-center  h-48 ${!image ? 'bg-furthly' : 'bg-transparent'} rounded-xl transition-all`}>
                {!image ? (
                  <>
                    <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                    <span className="text-sm text-white group-hover:text-secondary transition-colors">
                       {currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}
                    </span>
                  </>
                ) : (
                  <div className="relative w-full h-full">
                    <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                    <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                      <MdOutlineDeleteOutline className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
              <input type="file" name="icon" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange} required />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center w-full mt-5">
        <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
          {loading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 " xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            </>
          ) : (
            t("button.save")
          )}
        </button>
      </div>
    </form>
  );
};